import React, { useState } from "react";
import "../../styles/OurBrand.css";
import Lightbox from "../Lightbox";

const OurBrands = () => {
  const brand = [
    {
      name: "ORIMERCH",
      description:
        "Streetwear dan casual dengan teknik sablon manual dan efek khusus, diproduksi terbatas untuk kesan eksklusif dan kreatif tanpa batas.",
      image: "assets/img/brand/OM/1.jpg",
    },
    {
      name: "ORIKIDS",
      description:
        "Dirancang khusus untuk anak Indonesia, menampilkan outfit stylish, nyaman, dan berkualitas tinggi, mendukung rasa percaya diri dan masa depan cerah generasi penerus.",
      image: "assets/img/brand/OK/1.jpg",
    },
    {
      name: "ORIGINALITY SPORTWEAR (OGSW)",
      description:
        "Sportwear modern dan futuristik dengan bahan polyester berkualitas tinggi, ringan, elastis, dan tahan lama. Dilengkapi fitur anti-bacterial dan quick-dry, cocok untuk aktifitas sehari-hari dan olahraga.",
      image: "assets/img/brand/OGSW/1.jpg",
    },
  ];

  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImages, setLightboxImages] = useState([]);
  const [startIndex, setStartIndex] = useState(0);

  return (
    <section id="our-brand" className="our-brand section light-background">
      <div className="container">
        <div className="row gy-4">
          {/* Bagian Informasi */}
          <div className="col-lg-4" data-aos="fade-up" data-aos-delay="100">
            <div className="our-brand-box">
              <h3>Our Brands</h3>
              <p>
                Originality Clothing Company terus berinovasi dengan brand
                eksklusif berkarakter sebagai bukti konsistensi di industri
                fashion. Kami tidak sekadar menciptakan produk, tetapi ingin
                membangun pengalaman, kepercayaan, dan koneksi yang langgeng
                dengan pelanggan. Melalui Orimerch, Orikids, dan OGSW, kami
                menghadirkan fashion lokal berkualitas tinggi dengan harga
                terjangkau.
              </p>
              <div className="text-center">
                <a
                  href="https://wa.me/6281272800800"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="more-btn"
                >
                  <span>Shop Now</span> <i className="bi bi-chevron-right"></i>
                </a>
              </div>
            </div>
          </div>
          {/* Produk */}
          <div className="col-lg-8 d-flex align-items-stretch">
            <div className="row gy-4" data-aos="fade-up" data-aos-delay="200">
              {brand.map((product, index) => (
                <div className="col-xl-4" key={index}>
                  <div
                    className="product-box d-flex flex-column justify-content-center align-items-center"
                    role="button"
                    tabIndex={0}
                    onClick={() => {
                      const parts = product.image.split("/");
                      const brandPos = parts.indexOf("brand");
                      const folder = parts[brandPos + 1];
                      const counts = { OM: 9, OK: 8, OGSW: 5 };
                      const count = counts[folder] || 9;
                      const images = Array.from(
                        { length: count },
                        (_, i) => `assets/img/brand/${folder}/${i + 1}.jpg`,
                      );
                      setLightboxImages(images);
                      setStartIndex(0);
                      setLightboxOpen(true);
                    }}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        e.currentTarget.click();
                      }
                    }}
                  >
                    <img
                      src={product.image}
                      alt={product.name}
                      className="product-image"
                    />
                    <h4>{product.name}</h4>
                    <p>{product.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {lightboxOpen && (
        <Lightbox
          images={lightboxImages}
          initialIndex={startIndex}
          onClose={() => {
            setLightboxOpen(false);
            setLightboxImages([]);
          }}
        />
      )}
    </section>
  );
};

export default OurBrands;
